import { httpClient } from '@/services/httpClient';
import Bugsnag from '@bugsnag/js';

const getDashboards = async () => {
    try {
        const response = await httpClient.get('/api/v1/dashboards')

        return response.data
    } catch (error) {
        throw error
    }
}

const getDashboard = async (id) => {
    try {
        const response = await httpClient.get('/api/v1/dashboards/'+ id )

        return response.data
    } catch (error) {
        throw error
    }
}

const storeDashboard = async (payload) => {
    try {
        const response = await httpClient.post('/api/v1/dashboards', payload)

        return response.data
    } catch (error) {
        throw error
    }
}

const updateDashboard = async (id, payload) => {
    try {
        const response = await httpClient.put('/api/v1/dashboards/'+ id, payload)

        return response.data
    } catch (error) {
        throw error
    }
}

const archiveDashboard = async (id) => {
    try {
        const response = await httpClient.delete('/api/v1/dashboards/'+ id, null)

        return response.data
    } catch (error) {
        throw error
    }
}

export {
    getDashboards,
    getDashboard,
    storeDashboard,
    updateDashboard,
    archiveDashboard
}
